export default __webpack_public_path__ + "static/media/text.e916659e.svg";